module.exports = __webpack_public_path__ + "img/cw.003cae01.svg";